'use client';

import { List, ListItem, Typography } from '@coolblue-development/freddy';
import { useTranslation } from '@i18n/useTranslation';

import { getDisplayName } from '../../helpers/getDisplayName';
import { FilterRemover } from './FilterRemover';

const SelectedRow = ({
  filterIdentifier,
  displayValues
}: {
  filterIdentifier: string;
  displayValues: { filterName: string; filterValue: string[] };
}) => {
  const { t } = useTranslation('webshop.filterPage.selectedFilters');
  const { filterName, filterValue } = displayValues;

  const formatFilterValues = (values: string[]) => {
    const isCategory = filterIdentifier === 'producttype';

    if (isCategory) {
      values = values.map(value => getDisplayName(value, filterIdentifier));
    }

    if (values.length <= 1) return values[0];

    return t('filterSeparator', {
      filters: [values.slice(0, -1).join(', ')],
      lastFilter: values.slice(-1)[0],
      interpolation: { escapeValue: false }
    });
  };

  return (
    <List
      gap='none'
      marker='none'
      sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}
    >
      <ListItem>
        <Typography component='span'>
          {filterName}:
          <Typography component='strong' sx={{ wordBreak: 'break-word' }} pl={100}>
            {formatFilterValues(filterValue)}
          </Typography>
        </Typography>
      </ListItem>

      <ListItem>
        <FilterRemover
          displayValue={formatFilterValues(filterValue)}
          filterIdentifier={filterIdentifier}
        />
      </ListItem>
    </List>
  );
};

export { SelectedRow };
